import { render, staticRenderFns } from "./StudentProfile.vue?vue&type=template&id=33af211e&scoped=true"
import script from "./StudentProfile.vue?vue&type=script&lang=js"
export * from "./StudentProfile.vue?vue&type=script&lang=js"
import style0 from "./StudentProfile.vue?vue&type=style&index=0&id=33af211e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af211e",
  null
  
)

export default component.exports